import { useFundSizeList } from '../api';
import Loading from './Loading';
import NoData from '../components/NoData';
import Meta from '../components/Meta';
import moment from 'moment';
import './NavLess.sass';


const NavLess = (props) => {
	const { routeData } = props;
	const { apiData, isLoading, isError } = useFundSizeList();

	if (isError) return (
		<div id='NavLess'>
			<Meta data={routeData} />
			<NoData />
		</div>
	)

	if (isLoading) return <Loading />;

	return (
		<div id='NavLess'>
			<Meta data={routeData} />

			<div className='common-pad-wrap'>
				<h2>基金淨資產價值及受益人人數公告</h2>

				<div className='table-wrap'>
					<table>
						<thead>
							<tr>
								<th>基金名稱</th>
								<th>日期</th>
								<th>規模</th>
								<th>幣別</th>
								<th>受益人數量</th>
							</tr>
						</thead>

						<tbody>
							{apiData.resultP.map((item, index) => {
								const { twNameFull, etf020, ec006, ec501, ec503 } = item;
								const date = moment(ec503).format('YYYY/MM/DD');

								return (
									<tr key={`row${index}`}>
										<td>{twNameFull}</td>

										<td>{date}</td>

										<td>{etf020.toLocaleString()}</td>

										<td className='nowrap'>{ec006}</td>

										<td>{ec501.toLocaleString()}</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>

				<div className='notes'>
					<div className='flex-row'>備註 : </div>

					<div className='flex-row'>
						<div className='num'>(1)</div>
						<div className='text'>本資訊揭示係依據全系列基金信託契約及中華民國 109 年 04 月 24 日臺證上一字第 1091801537 號函規定辦理。</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NavLess;
